import { useEffect } from "react";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

const PREVIEW_HOSTS = [".preview.emergentagent.com", ".emergent.host", "localhost", "127.0.0.1"];
const PRODUCTION_URL = (process.env.REACT_APP_PUBLIC_SITE_URL || "").replace(/\/$/, "");

/** Sul dominio di preview (o in locale) le pagine non devono essere indicizzate. */
export function isPreviewHost(host = window.location.hostname) {
  return PREVIEW_HOSTS.some((h) => host === h || host.endsWith(h));
}

/** Base dei canonical: il dominio di produzione se configurato, altrimenti l'origine corrente. */
export function canonicalBase() {
  return PRODUCTION_URL || window.location.origin;
}

export function Seo({
  title,
  description,
  path = "",
  image,
  type = "website",
  publishedTime,
  modifiedTime,
  section,
  noindex = false,
}) {
  useEffect(() => {
    const preview = isPreviewHost();
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex || preview ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:site_name", "Osteria Aterrana");
    setMeta("property", "og:locale", "it_IT");
    setMeta("property", "og:type", type);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    const origin = window.location.origin;
    const base = canonicalBase();
    const url = `${base}${path}`;
    setMeta("property", "og:url", url);
    const absImage = image
      ? image.startsWith("http")
        ? image
        : `${origin}${image}`
      : `${origin}/logo-osteria-aterrana.png`;
    setMeta("property", "og:image", absImage);
    setMeta("name", "twitter:image", absImage);
    setMeta("property", "article:published_time", type === "article" ? publishedTime : "");
    setMeta("property", "article:modified_time", type === "article" ? modifiedTime : "");
    setMeta("property", "article:section", type === "article" ? section : "");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, path, image, type, publishedTime, modifiedTime, section, noindex]);
  return null;
}

export default Seo;
